export default __webpack_public_path__ + "static/chagahover-24f7185664298b0a5a35bbb3a07292b3.png";